import { createSelector } from 'reselect';

const bankAccountSelector = (state) => state.bankAccount;

export const selectBankAccounts = createSelector(
  bankAccountSelector,
  (state) => state.bankAccounts,
);
